import {useCallback} from 'react';
import {useHistory, useLocation} from 'react-router';

export const placementListUrl = (rootUrl: string) => `${rootUrl}/placement`;

export const referralOfferDetailUrl = (rootUrl: string) => `${rootUrl}/provider-offers-detail`;

type ReferralDetailArgs = {
    referralGuid: string;
    siblingReferralGuids?: Array<string>;
}

export const parameterizeArray = (key: string, arr: Array<string>) => {
    arr = arr.map(encodeURIComponent);
    return '?' + key + '=' + arr.join('&' + key + '=');
}

export function useGoToReferralDetailPage(args: ReferralDetailArgs) {
    const history = useHistory();
    const location = useLocation();
    const rootUrl = getClientPlacementRootUrl(location.pathname);
    const {referralGuid} = args;

    return useCallback(
        () => {
            if (referralGuid) {
                let url = referralOfferDetailUrl(rootUrl) + "/" + referralGuid;
                if (args.siblingReferralGuids != null && args.siblingReferralGuids.length > 0) {
                    url += parameterizeArray("siblingReferralGuids", args.siblingReferralGuids);
                }
                history.push(url);
            }
        },
        [history, referralGuid, args.siblingReferralGuids, rootUrl]
    );
}

export function useGoToReferralListPage() {
    const history = useHistory();
    const location = useLocation();
    const rootUrl = getClientPlacementRootUrl(location.pathname);

    return useCallback(
        () => {
            history.push(placementListUrl(rootUrl));
        },
        [history, rootUrl]
    );
}

export function getClientPlacementRootUrl(pathname: string): string {
    if (!pathname || pathname === '/') {
        return '/clientplacement';
    }

    const sections = pathname.split('/');
    return '/' + (sections[1] || 'clientplacement');
}

export function useGoToReferralListPageForPlacement() {
    const history = useHistory();
    const rootUrl = getClientPlacementRootUrl(history.location.pathname);

    return useCallback(
        () => {
            history.push(`${rootUrl}/placement`);
        },
        [rootUrl, history]
    );
}
